import { buildEndpoint } from './base.endpoints';

export const CONFIG_BASE_PATH = '/Config';

export const configEndpoints = {
  groups: () => buildEndpoint(`${CONFIG_BASE_PATH}/groups`),
  definitions: (group: string) => buildEndpoint(`${CONFIG_BASE_PATH}/definitions?group=${encodeURIComponent(group)}`),
  /** scopes string format: "ENTITY:guid,PRODUCT:guid" */
  effective: (group: string, scopes?: string) => {
    const base = `${CONFIG_BASE_PATH}/effective?group=${encodeURIComponent(group)}`;
    return buildEndpoint(scopes ? `${base}&scopes=${encodeURIComponent(scopes)}` : base);
  },
  effectiveValue: (configKey: string, scopes?: string) => {
    const base = `${CONFIG_BASE_PATH}/effective/${encodeURIComponent(configKey)}`;
    return buildEndpoint(scopes ? `${base}?scopes=${encodeURIComponent(scopes)}` : base);
  },
  values: () => buildEndpoint(`${CONFIG_BASE_PATH}/values`),
  scopes: (scopeType: string) => buildEndpoint(`${CONFIG_BASE_PATH}/scopes?scopeType=${encodeURIComponent(scopeType)}`),
} as const;

export default configEndpoints;
